module.exports = __webpack_public_path__ + "static/animan_2-62d2b75c7be42bf1ed99685a432b329e.png";